import type { UnknownOutputParams } from 'expo-router'
import type { ReactNode } from 'react'

import { useSearchParamsAction } from '@/src/general/hooks/useSearchParamsAction'

type TShareSearchParamsActionProps = {
  onShare: VoidFunction
  searchParams: UnknownOutputParams
}

export const ShareSearchParamsAction = ({ onShare, searchParams }: TShareSearchParamsActionProps): ReactNode => {
  useSearchParamsAction({
    searchParams,
    action: onShare,
    requestedQuery: { action: (actionValue) => actionValue === 'mail-share' || actionValue === 'share' },
  })
  return null
}
